import Vue from 'vue'
import ExternalImportTemplates from "./ExternalImportTemplates";

const fields = document.querySelectorAll('.external-import-templates-widget');

[...fields].forEach(el => {
    new Vue({
        name: 'external-import-templates-widget',
        el,
        components: {
            ExternalImportTemplates
        },
        methods: {
            setValue(value) {
                this.$refs.input.value = JSON.stringify(value);
            }
        }
    })
})

